import styled from '@olxui/core/dist/theme/styled';
import { P2, P4 } from '@olxui/core/dist/core/Typography';

export const LegendWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const DotInformation = styled.div`
    border-radius: 100%;
    background-color: ${({ theme }) =>
        theme.colors['background-brand-notification-neutral']};
    width: ${({ theme }) => theme.lineHeights[12]};
    height: ${({ theme }) => theme.lineHeights[12]};
    margin-right: ${({ theme }) => theme.space[8]};
`;

export const LineInformation = styled.div`
    border-top: 1px solid
        ${({ theme }) => theme.colors['borders-global-secondary']};
    width: 12px;
    margin-left: ${({ theme }) => theme.space[24]};
    margin-right: ${({ theme }) => theme.space[8]};
`;

export const StyledText = styled(P4)`
    color: ${({ theme }) => theme.colors['text-brand-primary']};
    font-weight: ${({ theme }) => theme.fontWeights['bold']};
    line-height: ${({ theme }) => theme.lineHeights[14]};
    margin: 0;
`;

export const StyledTitle = styled(P2)`
    font-weight: ${({ theme }) => theme.fontWeights['bold']};
    color: ${({ theme }) => theme.colors['text-brand-primary']};
    margin-bottom: ${({ theme }) => theme.space[16]};
    margin-top: 0;
`;
